import {FC, useEffect, useMemo} from 'react'
import { MenuComponent } from '../../../../../../../_metronic/assets/ts/components'
import { KTSVG } from '../../../../../../../_metronic/helpers'
import { DLMSiteApplication, useDLMSiteApplicationsListContext, getLastPathFromWorkflow, DLM_USER_RESPOND_STATES, claimDLMSiteApplication, DLM_USER_REASSIGN_APP_STATES, useDLMApplicationView, DLM_NO_TERMINATE_STATES, DLM_END_STATES, DLM_TYPE5_NO_TERMINATE_STATES } from '../../../../../core/doclabel'
import { useAuth } from '../../../../../auth'
import { useQueryClient, useMutation } from 'react-query'
import { cloneDeep, findIndex } from 'lodash'

type Props = {
  site: DLMSiteApplication
}

const DLMSiteApplicationsUserActionsCell: FC<Props> = ({site}) => {

  const {dlmAppData} = useDLMApplicationView();

  const appType = dlmAppData && dlmAppData?.dlmType && dlmAppData?.dlmType?.name ? dlmAppData.dlmType.name : '';
  
  const { setCurrentSite, workflow, setItemIDForDelete, setItemIDForUpdate, setObjectOption1, setResubmitData } = useDLMSiteApplicationsListContext();

  const { hasRole, currentUser} = useAuth();
  
  const queryClient = useQueryClient();

  const { id, canRespond, responseTitle, canClaim, appID, isTerminating, canReassign, assignRole, assignedId, canTerminate, canEdit } = useMemo(() => {
      
    if (! (site && currentUser) ) return { id: 0, canRespond : false, responseTitle: '', canClaim: false, appID : 0, canReassign: false, assignRole: '', assignedId : 0, canTerminate: false, canEdit: false};
    let responseTitle = "";

    const { id, state, assignedTo, dlmApplication } = site;
    const { id: appID } = dlmApplication;

    const isAssigned = (currentUser && assignedTo && currentUser.id === assignedTo.id) ? true : false;
    const assignedId = (assignedTo && assignedTo?.id && assignedTo.id > 0) ? assignedTo.id : 0;
    const canRespond = (state && DLM_USER_RESPOND_STATES.includes(site.state));

    const canClaim = canRespond && (! isAssigned) && hasRole('DLM Admin') && site.state === 'Admin Review';
    
    if (canRespond && isAssigned) {
        
      switch(state) {
        case 'Admin Review':
          responseTitle = 'Submit Review';
          break;
        case 'Site Inspection':
          responseTitle = 'Submit Inspection Result';
          break;
        case 'Site Inspection Review':
          responseTitle = 'Review Site Inspection';
          break;
        case 'Program Manager Approval':
          responseTitle = 'Submit Decision';         
          break;
        case 'Schedule For Sampling':
          responseTitle = 'Set Schedule';   
          break;
        case 'Testing in Progress':
          responseTitle = 'Submit Test Result';
          break;
        case 'Program Manager Approval - Admin Setup': 
          responseTitle = 'Perform Setup';
          break;
        case 'Program Manager Approved':
          responseTitle = 'Submit ROI';                    
          break;
        case 'Site Inspection Approved': 
          responseTitle = 'Submit ROI';
          break;
        case 'Inspection Setup':
          responseTitle = 'Setup Inspection';
          break;
        case 'Applicant Signed':
          responseTitle = 'Check Signed ROI';                  
          break;
        case 'ROI Pending SCDF Verification': 
          responseTitle = 'Finalize ROI';
          break;                
        default:
          responseTitle = 'Submit Response';
          break;
      }
    }


    const isTerminating = (hasRole('DLM Admin') && 
      (site.requestTerminateState && site.requestTerminateState === 'REQUEST_TERMINATE_APPLICATION')
    );  

    const canTerminate = (hasRole('DLM Admin') && (! DLM_END_STATES.includes(state)));  
    
    const canEdit = (hasRole('DLM Editor') && 
      (! (DLM_END_STATES.includes(state) || DLM_NO_TERMINATE_STATES.includes(state) || (appType === 'DLM Type 5' && DLM_TYPE5_NO_TERMINATE_STATES.includes(state))))             
    );  

    const reassignIdx = findIndex(DLM_USER_REASSIGN_APP_STATES, { state });     
    const assignRole = (reassignIdx > -1) ? DLM_USER_REASSIGN_APP_STATES[reassignIdx].role : '';
    const canReassign = (hasRole('DLM Admin') && (reassignIdx > -1));

    return { id, canRespond, responseTitle, canClaim, appID, isTerminating, canReassign, assignRole, assignedId, canTerminate, canEdit };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site, currentUser, appType]);
  

  //@ts-ignore
  const claimSiteApplication = useMutation(() => claimDLMSiteApplication(id, currentUser.id), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries(['DLMAPPLICATION-LOAD', { dlmappid: appID } ]);
      queryClient.invalidateQueries(['DLMAPPLICATIONS-LIST', { lastpath: getLastPathFromWorkflow(workflow) }])
      queryClient.invalidateQueries(['DLMAPPLICATIONS-LIST', { listmode: 'own'} ]);
    },
  })    


  const doEdit = () => {
    let site_labels = 0;                                        
    if (site.hasOwnProperty('siteApplicationDetails') && site.siteApplicationDetails.length > 0) {            
      site.siteApplicationDetails.forEach(_item => {
        if (_item?.quantity && _item.quantity > 0) {
            site_labels += parseInt(`${_item.quantity}`);                                                
        }
      })
    }                    

    // @ts-ignore
    setResubmitData({ 
      ...cloneDeep(dlmAppData),             
      siteApplications: [ site ], 
      totalLabelQuantity: site_labels 
    });   
  }

  useEffect(() => {
    if (canRespond || canClaim || isTerminating) {
      MenuComponent.reinitialization();
    }
  }, [canRespond, canClaim, isTerminating])

  if (! (canRespond || canClaim || isTerminating || canTerminate)) {
    return null;
  }

  return (
  <div className="align-top">
    <div      
      className='btn btn-light btn-active-light-primary btn-sm'
      data-kt-menu-trigger='click'
      data-kt-menu-attach='parent'
      data-kt-menu-placement='bottom-start'
    >
      Actions
      <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
    </div>      
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 py-4 mw-150px'
      data-kt-menu='true'
    >        
      { canClaim && 
      <div className='menu-item px-3' title="Claim Application">
        <div className='menu-link px-3' onClick={ async () => { await claimSiteApplication.mutateAsync()}} >
          Claim
        </div>
      </div>
      }
      { responseTitle && 
      <div className='menu-item px-3'>
        <div className='menu-link px-3' onClick={() => { setCurrentSite(site) }}>
          {responseTitle}
        </div>
      </div>  
      }    
      { (canReassign && setObjectOption1) &&
      <div className='menu-item px-3 text-start' title="Reassign Application">
        <div
          className='menu-link px-3' 
          onClick={() => setObjectOption1({
            siteApplicationid: id,
            assignRole, 
            assignedId
          })}
        >
          Reassign
        </div>
      </div>
      }
      { canEdit &&
      <div className='menu-item px-3 text-start' title="Edit Application">
        <div className='menu-link px-3 text-hover-danger' onClick={ () => doEdit()}>
          Edit
        </div>
      </div>
      }
      { canTerminate &&
      <div className='menu-item px-3 text-start' title="Terminate Application">
        <div className='menu-link px-3 text-hover-danger' onClick={ () => setItemIDForUpdate(id)}>
          Terminate
        </div>
      </div>
      }
      { isTerminating &&
      <div className='menu-item px-3' title="Process Termination">
        <div className='menu-link px-3' onClick={ () => setItemIDForDelete(id)} >
          Process Termination
        </div>
      </div>
      }                          
    </div>    
  </div>
  )
}

export {DLMSiteApplicationsUserActionsCell}
